import * as THREE from "three";
import { OtherDevices } from "./OtherDevices";
import { READ, FILTER } from "../../DATABASE/crud";
import { DeviceAvatar } from "./DeviceAvatar";

export class Devices {

  constructor(store) {
    this.store = store;
    this.container = document.createElement("div");
    this.devices = this.store.database.actualDevices || [];
    this.deviceAvatar = new DeviceAvatar(this.store)
    this.render();
  }

  render() {
    this.devices = this.store.database.actualDevices || [];
    this.filterdevices(this.devices);
    if(this.store.level.selectedColleague === null){return}
    return this.deviceAvatar.render(`/assets/faces/${this.store.level.selectedColleague.picture}`, this.devices)
  }



  filterdevices(devices) {
    const itCategories = [
      "Laptop",
      "Helyi nyomtató(usb)",
      "Monitor",
      "Dokkoló",
      "Sim kártya",
      "Mobiltelefon",
      "Hálózati nyomtató"
    ];

    this.store.level.itDevices = this.devices.filter(device => itCategories.includes(device.category));
    this.store.level.otherDevices = this.devices.filter(device => !itCategories.includes(device.category));
    this.store.level.itDevices.unshift({category: "__OTHER_DEVICES__", barcode: "Egyéb eszközök"});
    this.store.level.itDevices.unshift({category: "__PLUS__", barcode: "Új eszköz"});
    this.store.level.itDevices.unshift({category: "__CITIES__", barcode: "Települések"});
    this.store.level.itDevices.unshift({category: "__SET__", barcode: "Beállítások"});

  }

  resetLayout() {this.deviceAvatar.resetLayout();}

  update(delta) {
    if (this.store.level.levelName !== "COLLEAGUE") return;
    if (!this.store.level.modalOpen) return;

    this.deviceAvatar.update(delta);
}

}